var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1026,
    height: 238,
    viewBox: "0 0 1026 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.556 65.751C-47.589 65.751 82.9382 0.00361746 0.5 0V238H1025.48V107.424C989.759 107.424 989.759 65.751 949.914 65.751C897.703 65.751 916.938 177.805 872.971 177.805C822.409 177.805 798.777 139.837 763.054 139.837C727.331 139.837 723.209 177.805 657.258 177.805C591.307 177.805 598.177 107.424 547.34 107.424C496.503 107.424 497.877 139.837 440.171 139.837C397.578 139.837 400.326 65.751 341.245 65.751C282.164 65.751 312.391 177.805 206.596 177.805C100.8 177.805 159.881 65.751 92.556 65.751Z",
    fill: "url(#paint0_linear_1507_7890)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.293 65.7008C132.981 36.3006 84.172 11.0027 0.5 11V238H1025.48V36.9816C948.471 35.819 886.377 55.4449 856.744 90.315C824.562 128.183 735.419 163.471 676.849 127.917C618.278 92.3635 609.911 27.4121 520.661 27.4121C370.33 27.4121 449.54 147.745 293.352 147.745C137.164 147.745 184.674 104.415 155.293 65.7008Z",
    fill: "url(#paint1_linear_1507_7890)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1507_7890",
    x1: 512.991,
    y1: 0,
    x2: 512.991,
    y2: 238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8D3C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1507_7890",
    x1: 512.991,
    y1: 11,
    x2: 512.991,
    y2: 238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#782F86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2BB2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C2BB2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagram);
export default __webpack_public_path__ + "static/media/Diagram.1c9173c3e1849bcd65f94890f4838fc1.svg";
export { ForwardRef as ReactComponent };